import { useEffect,useCallback } from "react";
import { useRecoilState } from "recoil";
import { seasonRailcardsState, seasonRailcardsDefaultState } from "state";

import { getSeasonRailcards } from "../services/SeasonRailcardsService";
import { AuthApi } from "../api";
import customerAxiosInstance from "../api/customerAxiosInstance";

export const useFetchSeasonRailcards = ({ apiUrl, brand, env, customerData }) => {
  const [seasonRailcards, setSeasonRailcards] = useRecoilState(seasonRailcardsState);

  const fetchSeasonRailcards = useCallback(async () => {
    const isCustomerDataAvailable = !!customerData?.id;

    if (!isCustomerDataAvailable) {
      setSeasonRailcards(seasonRailcardsDefaultState)
      return
    }

    const authApi = AuthApi(apiUrl, customerData.apiAccessToken);
    const axiosInstance = customerAxiosInstance({
      apiUrl: `${apiUrl}/customers/${customerData.id}/season-railcards`,
      brand,
      env,
      customerData,
      authApi
    })
    const seasonRailcardsResponse = await getSeasonRailcards(axiosInstance);
    setSeasonRailcards(seasonRailcardsResponse);
  }, [apiUrl, brand, env, customerData, setSeasonRailcards]);

  useEffect(() => {
    fetchSeasonRailcards();
  }, [fetchSeasonRailcards, customerData]);

  return seasonRailcards;
};
